import { Exchange } from './constants';

export class PullEvent {
  abosAccountId: string;
  bitfinexAccountId: number;
  exchange: Exchange;

  constructor(abosAccountId: string, bitfinexAccountId: number, exchangeName: Exchange) {
    this.abosAccountId = abosAccountId;
    this.bitfinexAccountId = bitfinexAccountId;
    this.exchange = exchangeName;
  }
}
